<div class="container mt-3">
    <h2>Felaktiga mejl</h2>
    

    <table class="table border table-striped w-75">
        <thead>
            <tr>
                <th>Medlemsid</th>
                <th>Email</th>
                <th>Namn</th>
                <th>Status</th>
                <th *ngIf="userid===30127||userid===2058730">Orsak</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let mail of failedMails">
                <td><a [routerLink]="['/memberform/id/', mail.memberId]">{{mail.memberId}}</a></td>
                <td>{{ mail.email }}</td>
                <td>{{ mail.name }}</td>
                <td>{{ mail.status }}</td>
                <td *ngIf="userid===30127||userid===2058730">{{ mail.reason }}</td>
            </tr>
        </tbody>
    </table>
</div>

